export default {
  administrators: 'ADMINISTRATORS',
  administratorsOptions: 'ADMINISTRATORS_OPTIONS',
  administrator: 'ADMINISTRATOR',
  createAdministrator: 'CREATE_ADMINISTRATOR',
  updateAdministrator: 'UPDATE_ADMINISTRATOR',
  updateAdministratorStatus: 'UPDATE_ADMINISTRATOR_STATUS',
  deleteAdministrator: 'DELETE_ADMINISTRATOR',
};
